(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-slider"] && !Shopify.designMode) return;
  try {
    
  	$(function() {
		$('.home_slider_wrapper').slick({
			dots: true,
			arrows: false,
			slidesToShow: 1,
  			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000
		});
	});

  } catch(e) { console.error(e); }
})();
})();
